export const imageTypes = [".apng", ".avif", ".bmp", ".gif", ".ico", ".jpeg", ".jpg", ".png", ".svg", ".tiff", ".tif", ".webp"];
export const videoTypes = [".3gp", ".avi", ".flv", ".mkv", ".mov", ".mp4", ".mpeg", ".mpg", ".ogg", ".ogv", ".ts", ".webm", ".wmv"];
export const audioTypes = [".aac", ".aiff", ".alac", ".amr", ".flac", ".m4a", ".mp3", ".ogg", ".opus", ".wav", ".wma"];
